import { Tables } from "@/types";

interface IStripeStatus {
  connect: {
    onboarded: boolean;
    canCharge: boolean;
    canPayout: boolean;
  };
  subscription: {
    onboarded: boolean;
    inTrial: boolean;
    canUse: boolean;
  };
}

export function stripeStatus(tenant: Tables<"tenants"> | null | undefined): IStripeStatus {
  let result: IStripeStatus = {
    connect: {
      onboarded: false,
      canCharge: false,
      canPayout: false,
    },
    subscription: {
      onboarded: false,
      inTrial: false,
      canUse: false,
    },
  };

  if (!tenant) {
    return result;
  }

  if (tenant.stripe_subscription_price_id) {
    result.subscription.onboarded = true;
    result.subscription.inTrial = tenant.stripe_subscription_status === "trialing";
    result.subscription.canUse = ["active", "trialing"].includes(tenant.stripe_subscription_status ?? "");
  }

  if (tenant.stripe_account_id && tenant.charges_enabled !== null) {
    result.connect.onboarded = true;
    result.connect.canCharge = tenant.charges_enabled ?? false;
    result.connect.canPayout = tenant.payouts_enabled ?? false;
  }
  return result;
}
